import BasePage from "$app/utils/base_page";

import "./inertia";

BasePage.initialize();
